import { createStore, applyMiddleware, Store, Middleware } from 'redux';
import { reducer } from './reducer';
import { routerMiddleware } from 'react-router-redux';
import { History } from 'history';
import createSagaMiddleware from 'redux-saga';
import { all } from 'redux-saga/effects';
import { sagas as apiSagas } from 'api/sagas';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';

/* Root saga that combines all sagas */
function* rootSaga() {
    yield all(apiSagas);
}

/* Create the saga middleware */
const sagaMiddleware = createSagaMiddleware();

/* Function to configure and create the Redux store */
export const configureStore = (history: History, initialState: any): Store => {
    const middlewares: Array<Middleware> = [
        routerMiddleware(history) as Middleware,
        sagaMiddleware,
        thunk as Middleware,
        logger as Middleware
    ];

    const store: Store = createStore(
        reducer,
        initialState as any,
        composeWithDevTools({})(applyMiddleware(...middlewares))
    );

    /* Run the root saga */
    sagaMiddleware.run(rootSaga);
    return store;
};